import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const SettingsFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M12 9.77c-1.23 0-2.23 1-2.23 2.23s1 2.23 2.23 2.23 2.23-1 2.23-2.23-1-2.23-2.23-2.23Z" />
      <Path d="M19.37 6.56 13 2.88c-.61-.35-1.37-.35-1.98 0L4.65 6.56c-.61.35-.99 1.01-.99 1.72v7.36c0 .71.38 1.37.99 1.72l6.37 3.68c.31.18.65.26.99.26.34 0 .69-.09.99-.26l6.37-3.68c.61-.35.99-1.01.99-1.72V8.28c0-.71-.38-1.37-.99-1.72ZM12 15.94A3.95 3.95 0 0 1 8.05 12c0-2.17 1.77-3.95 3.95-3.95s3.95 1.77 3.95 3.95-1.77 3.94-3.95 3.94Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default SettingsFilled
